
import { useState } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BackToTop from "@/components/ui/BackToTop";
import EducationHeader from "@/components/civic-education/EducationHeader";
import ContentSearch from "@/components/civic-education/ContentSearch";
import ContentTabs from "@/components/civic-education/ContentTabs";
import { useCivicEducationContent } from "@/hooks/useCivicEducationContent";

const CivicEducation = () => {
  const [activeTab, setActiveTab] = useState("all");
  const { 
    filteredContent, 
    searchTerm, 
    setSearchTerm, 
    activeFilter, 
    setActiveFilter,
    activeTagFilter,
    setActiveTagFilter,
    fromDate,
    setFromDate,
    toDate,
    setToDate, 
    latestTags,
    allTags,
    hasContent
  } = useCivicEducationContent();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <section className="bg-nation-gray-light py-16">
          <div className="container mx-auto px-4">
            <EducationHeader />
            
            <ContentSearch 
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              activeTagFilter={activeTagFilter}
              setActiveTagFilter={setActiveTagFilter}
              latestTags={latestTags}
              allTags={allTags}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
            />
            
            <div className="max-w-4xl mx-auto">
              <ContentTabs 
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                filteredPodcasts={filteredContent.podcasts}
                filteredVideos={filteredContent.videos}
                filteredSummaries={filteredContent.summaries}
                hasContent={hasContent}
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default CivicEducation;
